import { Editor } from '@tiptap/react'
import { Button, Popover, Tooltip } from 'antd'
import EmojiPicker, { EmojiClickData } from 'emoji-picker-react'
import { EmojiHappy } from 'iconsax-react'
import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

type Props = {
  editor: Editor
}

export const EmojiButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)
  const { styles } = useStyles()

  const onEmojiClick = (emojiData: EmojiClickData) => {
    editor.chain().focus().insertContent(emojiData.emoji).run()
    setOpen(false)
  }

  return (
    <Tooltip title={t('editor.emoji')}>
      <Popover
        content={
          <div className={styles.emojiPickerContainer}>
            <EmojiPicker
              onEmojiClick={onEmojiClick}
              width="100%"
              height={400}
              previewConfig={{
                showPreview: false
              }}
            />
          </div>
        }
        trigger="click"
        open={open}
        onOpenChange={setOpen}
        placement="bottom"
      >
        <Button icon={<EmojiHappy size={14} />} />
      </Popover>
    </Tooltip>
  )
}
